export default {
  form: {
    address: {
      delivery: {
        placeholder: 'Search your delivery address',
      },
      placeholder: 'Enter address to find nearest location',
    },
  },
  toasts: {
    failed_to_load_stores: 'Failed to load stores, please refresh the page',
  },
  errors: {
    no_delivery_companies: 'Delivery not available for this address',
    delivery_not_available: "Unfortunately, we don't offer delivery at the moment",
    location_unavailable: "Couldn't access your location, please enable permissions or enter the address manually",
    location_lookup_failed: "Couldn't look up your address, please try again",
    address_suggestions_unavailable: "Address suggestions couldn't load.",
  },
  buttons: {
    use_current_location: 'Use my current location',
    locating: 'Finding your location…',
    retry: 'Try again',
  },
};
